import {
  Auth0ContextInterface,
  useAuth0 as useAuth,
  User,
} from '@auth0/auth0-react';

import { ENV } from '@utils/env';

const mockAuth0: Partial<Auth0ContextInterface<User>> = {
  isAuthenticated: true,
  logout: () => Promise.resolve(),
  loginWithRedirect: () => Promise.resolve(),
  getAccessTokenSilently: (options) => {
    if (options?.detailedResponse) {
      return Promise.resolve({
        access_token: 'token',
        id_token: 'token',
        token_type: 'Bearer',
        expires_in: 3600,
        scope: 'openid profile email',
      });
    } else {
      return Promise.resolve('token') as any;
    }
  },
};

export function useAuth0() {
  const auth = useAuth();

  if (ENV.mode === 'test') {
    return { ...auth, ...mockAuth0 };
  } else {
    return auth;
  }
}
